<template>
  <v-container fluid fill-height class="px-0">
    <v-row align="center" class="mt-n2 mb-2" dense>
      <v-col cols="12" class="d-flex justify-start align-center">
        <h5 class="text-h5 font-weight-bold primary--text mr-4">Recepción de Muestras</h5>
        <v-btn color="secondary" @click="showExportSamplesModal = true" rounded small elevation="0">
          <v-icon left size="18">mdi-file-document</v-icon>
          Muestras registradas
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-n2">
      <v-col cols="12" class="py-0">
        <v-card flat class="rounded-xl overflow-hidden shadow-soft">
          <v-tabs v-model="tabs" color="primary" active-class="font-weight-bold" slider-size="4" centered grow>
            <v-tab class="text-subtitle-2 px-10">Muestras en proceso</v-tab>
            <v-tab class="text-subtitle-2 px-10">Muestras en laboratorio</v-tab>

            <v-tab-item class="grey lighten-5">
              <v-container fluid v-if="tabs == 0" class="pa-4">
                <SampleTransit />
              </v-container>
            </v-tab-item>
            <v-tab-item class="grey lighten-5">
              <v-container fluid v-if="tabs == 1" class="pa-4">
                <SampleReception />
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
    <ExportSamplesModal v-model="showExportSamplesModal" v-if="showExportSamplesModal"/>
  </v-container>
</template>

<script>
//components
import SampleTransit from "@/components/reception/SampleTransit.vue";
import SampleReception from "@/components/reception/SampleReception.vue";
import ExportSamplesModal from "../components/reception/modals/ExportSamplesModal.vue";
// import Shipments from "@/components/logistic/Shipments.vue";

export default {
  components: {
    SampleTransit,
    SampleReception,
    ExportSamplesModal
    // Shipments,
  },
  data: () => ({
    tabs: 0,
    showExportSamplesModal:false
  }),
  mounted() {
    switch (this.$route.params.tab) {
      // case "transit":
      //   this.tabs = 0;
      //   break;
      case "process":
        this.tabs = 0;
        break;
      case "reception":
        this.tabs = 1;
        break;
    }
  },
  watch: {
    tabs(value) {
      switch (value) {
        case 0:
          if ("process" != this.$route.params.tab) {
            this.$router.replace({
              params: {
                tab: "process",
              },
            });
          }
          break;
        case 1:
          if ("reception" != this.$route.params.tab) {
            this.$router.replace({
              params: {
                tab: "reception",
              },
            });
          }
          break;
      }
    },
    "$route.params.tab"(value) {
      switch (value) {
        case "process":
          this.tabs = 0;
          break;
        case "reception":
          this.tabs = 1;
          break;
      }
    },
  },
};
</script>

